import api from '@/utils/axios';
import { unwrapList } from '@/utils/apiHelpers';
import { getMe } from '@/domains/auth/services/auth.service';
import type { ApiNamedResource, ApiUser } from './types';
import { listUserPermissions, syncUserPermissions, detachUserPermission } from './configuration.api';

export {
  listUserPermissions,
  syncUserPermissions,
  detachUserPermission,
};

/** Catalogue des permissions : union des permissions assignées aux utilisateurs + session courante. */
export async function fetchPermissionCatalog(): Promise<ApiNamedResource[]> {
  const byId = new Map<number, ApiNamedResource>();

  try {
    const res = await api.get('/users');
    const users = unwrapList<ApiUser>(res.data);
    for (const user of users) {
      for (const p of user.permissions ?? []) {
        byId.set(p.id, p);
      }
    }
  } catch {
    /* ignore */
  }

  try {
    const me = (await getMe()) as ApiUser;
    for (const p of me.permissions ?? []) {
      byId.set(p.id, p);
    }
  } catch {
    /* ignore */
  }

  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
}

export function isStaffUser(user: ApiUser): boolean {
  return user.types?.some((t) => t.name === 'admin' || t.name === 'super_admin') ?? false;
}

export function isSuperAdminUser(user: ApiUser): boolean {
  return user.types?.some((t) => t.name === 'super_admin') ?? false;
}

export const PERMISSION_LABELS: Record<string, string> = {
  view: 'Consultation',
  add: 'Création',
  edit: 'Modification',
  delete: 'Suppression',
  confidential: 'Données confidentielles',
};

export function permissionLabel(name: string): string {
  return PERMISSION_LABELS[name] ?? name;
}
